import { render } from "./UtopiaUpdate.vue?vue&type=template&id=5c2481ba"
import script from "./UtopiaUpdate.vue?vue&type=script&lang=js"
export * from "./UtopiaUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__